<div class="row clearfix">
  <div class="col-6 col-md-4 col-xl-4">
    <div class="card">
      <div class="card-body ribbon">
        <a
          href="#"
          class="my_sort_cut text-muted"
          routerLink="/reports-intermediate"
          ><i class="fa fa-line-chart"></i><span>Project Performance</span></a
        >
      </div>
    </div>
  </div>
  <div class="col-6 col-md-4 col-xl-4">
    <div class="card">
      <div class="card-body ribbon">
        <a href="#" class="my_sort_cut text-muted" routerLink="/reports-overall"
          ><i class="fa fa-table"></i><span>Overall</span></a
        >
      </div>
    </div>
  </div>
</div>
